// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a2b157b3","453":"d289632f"}[chunkId] + ".chunk.js";
};